import { render, staticRenderFns } from "./ChannelFreeStatistics.vue?vue&type=template&id=1872a582&scoped=true&lang=html"
import script from "./ChannelFreeStatistics.vue?vue&type=script&lang=js"
export * from "./ChannelFreeStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1872a582",
  null
  
)

export default component.exports